/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CrudJournalEventBaseComponent from "core/components/forc/abstract/crud-journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import TreatmentHistoryChangedJournalEvent from "core/models/treatment-history-changed-journal-event";
export default class TreatmentHistoryEditionFormComponent extends CrudJournalEventBaseComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceJournalEvent);
  }
  get model() {
    if (this.isNewMode) {
      const attrs = {
        surgerySurgeries: [],
        chemotherapies: [],
        oncologies: [],
        radiotherapies: [],
        immunotherapies: [],
        targetedTherapies: [],
        hormonotherapies: [],
        otherFollowUpEvents: [],
        protocols: []
      };
      return this.store.createRecord("treatment-history-changed-journal-event", {
        occurredAt: new Date(),
        ...attrs
      });
    }
    return this.retrievedJournalEvent;
  }
  async save() {
    const je = await super.save();
    await je.clearAndFetchAssociatedTaskAndConsultation();
    return je;
  }
}
_defineProperty(TreatmentHistoryEditionFormComponent, "forcDisplayName", "Historique des traitements");
_defineProperty(TreatmentHistoryEditionFormComponent, "fullComponentId", "treatment-history/edition-form");
_defineProperty(TreatmentHistoryEditionFormComponent, "journalEventClass", TreatmentHistoryChangedJournalEvent);